import { useNavigate } from 'react-router-dom'; 
import inst from "../assets/Ins.png";
import face from "../assets/Face.png";
import you from "../assets/You.png";
import lin from "../assets/Lin.png";
import twi from "../assets/Twi.png";
import news from "../assets/News.png";
import phone from "../assets/phone.png";
import mail from "../assets/Mail.png";
import loc from "../assets/Loc.png";
import nlen from "../assets/Nlen.svg";
import user from "../assets/user.png";  
import { Link } from 'react-router-dom';
import {useAnimation } from "framer-motion";
import { toast, ToastContainer } from "react-toastify";
import dd from "../assets/DD.png";
import ar from "../assets/Ar.png";
import logo from "../assets/logo.png";
import emojiLeft from '../assets/emoji-left.svg';
import emojiRight from '../assets/emoji-right.svg';
import emojiParty from '../assets/emoji-party.svg';
import emojiConfetti from '../assets/emoji-confetti.svg';

// // import React, { useEffect, useState, useRef } from "react";
// // import founderImg from "../assets/founder.png";
// // import productImg from "../assets/product.png";
// // import eventImg from "../assets/growth.png";
// // import extraImg from "../assets/growth.png"; // Replace with real image if needed

// const timelineData = [
//   {
//     date: "24 May 2019",
//     title: "Lentera is founded",
//     description:
//       "Lentera began its journey from a modest apartment in Chennai, driven by a single vision — to build smart, purpose-driven technology that empowers businesses to work better.",
//     image: founderImg,
//   },
//   {
//     date: "24 August 2020",
//     title: "First B2B product launch",
//     description:
//       "Lentera launched its first major B2B SaaS platform, marking a significant milestone in the company’s growth.",
//     image: productImg,
//   },
//   {
//     date: "15 March 2022",
//     title: "Major industry event",
//     description:
//       "Presented at a major industry conference, showcasing Lentera’s innovative capabilities to the tech world.",
//     image: eventImg,
//   },
//   {
//     date: "10 Jan 2024",
//     title: "Expanded global partnerships",
//     description:
//       "Lentera entered global partnerships, expanding its reach into Europe and Southeast Asia.",
//     image: extraImg,
//   },
// ];

// const Timeline = () => {
//   const [activeIndexx, setActiveIndexx] = useState(-1);
//   const [hasFinished, setHasFinished] = useState(false);
//   const [lineHeight, setLineHeight] = useState(0);
//   const startDotRef = useRef(null);
//   const endDotRef = useRef(null);
//   const lineRef = useRef(null);

//   useEffect(() => {
//     const handleScroll = () => {
//       if (hasFinished) return;
//       const vh = window.innerHeight;
//       let maxVisible = -1;
//       timelineData.forEach((_, idx) => {
//         const el = document.getElementById(`step-${idx}`);
//         if (el && el.getBoundingClientRect().top < vh * 0.75) {
//           maxVisible = idx;
//         }
//       });
//       if (maxVisible !== -1) {
//         setActiveIndexx((prev) => (maxVisible > prev ? maxVisible : prev));
//         if (maxVisible === timelineData.length - 1) {
//           setHasFinished(true);
//         }
//       }
//     };

//     const calcLineHeight = () => {
//       if (startDotRef.current && endDotRef.current && lineRef.current) {
//         const startY = startDotRef.current.getBoundingClientRect().top + window.scrollY;
//         const endY = endDotRef.current.getBoundingClientRect().top + window.scrollY;
//         setLineHeight(endY - startY);
//       }
//     };

//     window.addEventListener("scroll", handleScroll, { passive: true });
//     window.addEventListener("resize", calcLineHeight);
//     handleScroll();
//     calcLineHeight();

//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//       window.removeEventListener("resize", calcLineHeight);
//     };
//   }, [hasFinished]);

//   return (
//     <section className="relative bg-[#F9FAFB] py-20 px-4 sm:px-6 lg:px-16 scroll-smooth">
//       <div className="max-w-7xl mx-auto relative">
//         {/* Absolute timeline line */}
//         <div
//           ref={lineRef}
//           className="absolute left-1/2 w-[2px] bg-gray-300 transform -translate-x-1/2 z-0"
//           style={{ top: startDotRef.current?.offsetTop, height: `${lineHeight}px` }}
//         >
//           <div
//             className="absolute top-0 left-0 w-full bg-green-600 transition-all duration-700 ease-in-out"
//             style={{
//               height: `${(activeIndexx + 1) * (lineHeight / timelineData.length)}px`,
//             }}
//           />
//         </div>

//         {timelineData.map((step, i) => {
//           const isEven = i % 2 === 0;
//           const isFirst = i === 0;
//           const isLast = i === timelineData.length - 1;
//           return (
//             <div
//               key={i}
//               id={`step-${i}`}
//               className="relative py-20 flex flex-col md:flex-row items-center justify-between gap-12"
//             >
//               {/* Dot */}
//               <div
//                 ref={isFirst ? startDotRef : isLast ? endDotRef : null}
//                 className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10"
//               >
//                 <div
//                   className={`w-4 h-4 rounded-full border-4 ${
//                     activeIndexx >= i
//                       ? "bg-green-600 border-green-600"
//                       : "bg-white border-gray-400"
//                   }`}
//                 />
//               </div>

//               {/* Side A */}
//               <div className={`w-full md:w-1/2 flex justify-center items-start ${isEven ? "order-1" : "order-2"}`}>
//                 <div className="relative">
//                   <div className={`absolute top-0 ${isEven ? 'right-0 translate-x-1/2' : 'left-0 -translate-x-1/2'} -translate-y-1/2 z-30`}>
//                     <div className="bg-gradient-to-r from-[#7B41E6] to-[#EF3BF2] text-white text-sm w-[157px] h-[34px] flex items-center justify-center rounded-full border-2 border-white shadow-md">
//                       {step.date}
//                     </div>
//                   </div>
//                   <div className="w-[320px] h-[320px] rounded-full overflow-hidden shadow-lg bg-white border-[6px] border-white flex items-center justify-center">
//                     <img
//                       src={step.image}
//                       alt={step.title}
//                       className="w-full h-full object-cover rounded-full"
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* Side B */}
//               <div className={`w-full md:w-1/2 flex justify-center items-start ${isEven ? "order-2" : "order-1"}`}>
//                 <div className="bg-white shadow-lg rounded-xl p-6 w-full max-w-[492px] text-left">
//                   <h3 className="text-2xl font-bold text-gray-900 mb-3">
//                     {step.title}
//                   </h3>
//                   <p className="text-gray-600 text-base leading-relaxed">
//                     {step.description}
//                   </p>
//                 </div>
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     </section>
//   );
// };

// export default Timeline;

import { motion } from "framer-motion";

// Importing images from src/assets
import simage1 from "../assets/simage1.png";
import simage2 from "../assets/simage2.png";
import simage3 from "../assets/simage3.png";
import simage4 from "../assets/simage4.png";
import simage5 from "../assets/simage5.png";
import simage6 from "../assets/simage6.png";
import simage7 from "../assets/simage7.png";
import simage8 from "../assets/simage8.png";
import simage9 from "../assets/simage9.png";
import simage10 from "../assets/simage10.png";
import simage11 from "../assets/simage11.png";
import simage12 from "../assets/simage12.png";
import simage13 from "../assets/simage13.png";
import simage14 from "../assets/simage14.png";
import simage15 from "../assets/simage15.png";
import simage16 from "../assets/simage16.png";
import simage17 from "../assets/simage17.png";
import simage18 from "../assets/simage18.png";

import sparkIcon from "../assets/spark-icon.png";
import rocketIcon from "../assets/rocket-icon.png";
import sasikumar from "../assets/sasikumarr.png";
import milestoneImage from "../assets/milestone.png";     // 🎯 Main illustration
import emojiStar from "../assets/emoji2.png";             // 🤩 Emoji
import paperPlane from "../assets/paper-planee.png";      // ✈️ Decoration
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";




import React, { useEffect, useState, useRef } from "react";
import founderImg from "../assets/founder.png";
import productImg from "../assets/product.png";
import clientImg from "../assets/clients.png";
import countryImg from "../assets/country.png"; // Replace with real image if needed
import globalImg from "../assets/global.png";
import memberImg from "../assets/members.png";

import curveIcon from "../assets/icon-left.png";
import arrowIcon from "../assets/icon-moment.png";

const imagess = [
  simage1, simage2, simage3, simage4,
  simage5, simage6, simage7, simage8,simage9,simage10, simage11, simage12, simage13,simage14,simage15, simage16, simage17, simage18,
];

export default function OurStoryTopSection() {
  const sectionRef = useRef(null);
  const [startCount, setStartCount] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStartCount(false); // Reset first
          setTimeout(() => setStartCount(true), 100); // Retrigger count
        }
      },
      { threshold: 0.4 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);
  const [ref, inView] = useInView({
    threshold: 0.4,
    triggerOnce: false, // Re-trigger every time it scrolls into view
  });
  const [activeIndex, setActiveIndex] = useState(0);
  const sectionRefs = [useRef(null), useRef(null), useRef(null)];

  const images = [
    {
      src: sparkIcon,
      // circleColor: "bg-green-200",
      alt: "Spark Icon",
    },
    {
      src: rocketIcon,
      // circleColor: "bg-pink-200",
      alt: "Rocket Icon",
    },
    {
      src: sasikumar,
      // circleColor: "",
      alt: "Sasi Kumar S",
    },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const offsets = sectionRefs.map((ref) =>
        ref.current ? ref.current.getBoundingClientRect().top : 9999
      );

      const active = offsets.findIndex((top) => top > window.innerHeight * 0.2);
      setActiveIndex(active === -1 ? 2 : Math.max(0, active - 1));
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // initialize on load
      
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const timelineData = [
  {
    date: "24 May 2019",
    title: "Lentera is founded",
    description:
      "Lentera began its journey from a modest apartment in Chennai, driven by a single vision — to build smart, purpose-driven technology that empowers businesses to work better.",
    image: founderImg,
  },
  {
    date: "24 August 2020",
    title: "First B2B product launch",
    description:
      "Lentera launched its first major B2B SaaS platform, marking a significant milestone in the company’s growth.",
    image: productImg,
  },
  {
    date: "24 september 2021",
    title: "Crossed 50 clients",
    description:
      "We are proud to have surpassed 50+ satisfied clients, a testament to our dedication to excellence and customer success.",
    image: clientImg,
  },
  {
    date: "24 October 2022",
    title: "Expanded across 4+ countries",
    description:
      "We have successfully expanded our service footprint across more than four countries, reinforcing our commitment to delivering consistent, high-quality solutions on a global scale.",
    image: countryImg,
  },
  {
    date: "24 June 2023",
    title: "Scaling Innovation, Globally",
    description:
      "We are committed to scaling innovation across global markets, delivering transformative solutions that drive growth and efficiency worldwide",
    image: globalImg,
  },
  {
    date: "24 December 2024",
    title: "Grown to over 35+ members",
    description:
      "We have expanded our workforce to more than 35+ skilled employees, reflecting our steady growth and commitment to excellence.",
    image: memberImg,
  },

];
const stats = [
  { number: 6, suffix: "+", label: "Years in Business" },
  { number: 50, suffix: "+", label: "Expert Teams" },
  { number: 15, suffix: "+", label: "Products" },
  { number: 4, suffix: "", label: "Countries Served" },
  { number: 50000, suffix: "+", label: "Users" },
  { number: 220, suffix: "+", label: "Projects Completed" },
];
// const stats = [
//     { number: "6+", label: "Years in Business" },
//     { number: "50+", label: "Expert Teams" },
//     { number: "15+", label: "Products" },
//     { number: "4", label: "Countries Served" },
//     { number: "50K+", label: "Users" },
//     { number: "220+", label: "Projects Completed" },
//   ];
   const [activeIndexx, setActiveIndexx] = useState(-1);
  const [hasFinished, setHasFinished] = useState(false);
  const [lineHeight, setLineHeight] = useState(0);
  const startDotRef = useRef(null);
  const endDotRef = useRef(null);
  const lineRef = useRef(null);

  useEffect(() => {
  const handleScroll = () => {
    if (hasFinished) return;
    const scrollY = window.scrollY;
    const vh = window.innerHeight;
    let maxVisible = -1;

    for (let i = 0; i < timelineData.length; i++) {
      const el = document.getElementById(`step-${i}`);
      if (!el) continue;

      const rect = el.getBoundingClientRect();
      const elTop = rect.top + window.scrollY;

      // Trigger when the center of the card hits 50% of the viewport
      if (scrollY + vh * 0.5 >= elTop) {
        maxVisible = i;
      }
    }

    if (maxVisible !== -1) {
      setActiveIndexx((prev) => (maxVisible > prev ? maxVisible : prev));
      if (maxVisible === timelineData.length - 1) {
        setHasFinished(true);
      }
    }
  };

  const calcLineHeight = () => {
    if (startDotRef.current && endDotRef.current && lineRef.current) {
      const startY = startDotRef.current.getBoundingClientRect().top + window.scrollY;
      const endY = endDotRef.current.getBoundingClientRect().top + window.scrollY;
      setLineHeight(endY - startY);
    }
  };

  window.addEventListener("scroll", handleScroll, { passive: true });
  window.addEventListener("resize", calcLineHeight);
  requestAnimationFrame(() => {
    handleScroll();
    calcLineHeight();
  });

  return () => {
    window.removeEventListener("scroll", handleScroll);
    window.removeEventListener("resize", calcLineHeight);
  };
}, [hasFinished]);


   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
          // const [isServicesOpen, setIsServicesOpen] = useState(false);
          // const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
          // const [isCompanyOpen, setIsCompanyOpen] = useState(false);
        
          const toggleMobileMenu = () => {
            setIsMobileMenuOpen(!isMobileMenuOpen);
          };
        
          // const toggleServicesDropdown = () => {
          //   setIsServicesOpen(!isServicesOpen);
          // };
        
          // const toggleIndustriesDropdown = () => {
          //   setIsIndustriesOpen(!isIndustriesOpen);
          // };
        
          // const toggleCompanyDropdown = () => {
          //   setIsCompanyOpen(!isCompanyOpen);
          // };
    const [data, setData] = useState("");
      const [sessionid, setSessionid] = useState("");
      const [email, setEmail] = useState("");
      const [token, setToken] = useState("");
      useEffect(() => {
        fetch("https://api-uat.mawalog.com/admin/v2/api/website")
          .then((response) => response.json())
          .then((json) => {
            setData(json.data.captcha_code);
            setSessionid(json.data.session_id);
            setToken(json.data.token);
          })
          .catch((error) => console.error("Error fetching data:", error));
      }, []);
      useEffect(() => {
        const canvas = document.getElementById("captchaCanvas");
        if (canvas) {
          const ctx = canvas.getContext("2d");
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.font = "bold 18px Arial";
          ctx.fillStyle = "#00377B";
          ctx.fillText(data, 10, 22); // assuming 'data' holds the captcha string
        }
      }, [data]);
      const handleChange = (e) => {
        setEmail(e.target.value);
      };
     
       const canvasRef = useRef(null);
      const [captchaValue, setCaptchaValue] = useState(""); // text from API
      const [userCaptcha, setUserCaptcha] = useState("");
     
        /* ------------------------------------------------------------------- API fetch */
      const fetchCaptcha = async () => {
        try {
          const res = await fetch(
            "https://api-uat.mawalog.com/admin/v2/api/website"
          );
          const json = await res.json();
          setCaptchaValue(json.data.captcha_code ?? "ERROR"); // fallback if NULL
        } catch (err) {
          console.error("Error fetching captcha:", err);
        }
      };
     
      /* -- fetch once on mount ------------------------------------------------------- */
      useEffect(() => {
        fetchCaptcha();
      }, []);
     
      /* -- redraw every time captchaValue changes ------------------------------------ */
      useEffect(() => {
        if (!data) return; // nothing to paint yet
        const canvas = canvasRef.current;
        if (!canvas) return;
     
        const ctx = canvas.getContext("2d");
        const W = canvas.width;
        const H = canvas.height;
     
        /* ========= clear & background */
        ctx.clearRect(0, 0, W, H);
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, W, H);
     
        /* ========= random faint bezier curves (extra distortion) */
        for (let i = 0; i < 3; i++) {
          ctx.beginPath();
          ctx.moveTo(Math.random() * W, Math.random() * H);
          ctx.bezierCurveTo(
            Math.random() * W,
            Math.random() * H,
            Math.random() * W,
            Math.random() * H,
            Math.random() * W,
            Math.random() * H
          );
          ctx.lineWidth = 1 + Math.random(); // 1-2 px
          ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
          ctx.stroke();
        }
     
        /* ========= characters (uneven) */
        ctx.font = "bold 22px Arial";
        ctx.fillStyle = "#0A3A72";
        const chars = data.toString().split("");
     
        chars.forEach((ch, i) => {
          const angle = (Math.random() - 0.5) * 0.8; // ±23°
          const x = 8 + i * 14 + (Math.random() * 4 - 2);
          const y = 22 + (Math.random() * 6 - 3);
     
          ctx.save();
          ctx.translate(x, y);
          ctx.rotate(angle);
          ctx.fillText(ch, 0, 0);
          ctx.restore();
        });
     
        /* ========= dots */
        for (let i = 0; i < 45; i++) {
          ctx.beginPath();
          ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
          ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
          ctx.fill();
        }
      }, [data]);
     
      /* -- reload button click ------------------------------------------------------- */
      const handleReload = () => {
        fetch("https://api-uat.mawalog.com/admin/v2/api/website")
          .then((response) => response.json())
          .then((json) => {
            setData(json.data.captcha_code);
            setSessionid(json.data.session_id);
            setToken(json.data.token);
          })
          .catch((error) => console.error("Error fetching data:", error));
      };
        const handleSubscribe = async () => {
        try {
          const response = await fetch(
            "https://api-uat.mawalog.com/admin/v2/api/newsletter",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-CSRF-TOKEN": token,
              },
              body: JSON.stringify({
                session_id: sessionid,
                captcha: userCaptcha,
                email: email,
                type: "Mawalog",
              }),
            }
          );
     
          const result = await response.json();
          console.log("Response:", userCaptcha, " ", data);
          setEmail("");
         setUserCaptcha("");
          toast(result.message);
        } catch (error) {
          console.error("Error sending request:", error);
        }
      };
      const [openDropdown, setOpenDropdown] = useState(null);
      const navRef = useRef(null);
    
      // Close dropdown on outside click
      useEffect(() => {
        const handleClickOutside = (event) => {
          if (navRef.current && !navRef.current.contains(event.target)) {
            setOpenDropdown(null);
          }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
      }, []);
    
      const toggleDropdown = (dropdown) => {
        setOpenDropdown(openDropdown === dropdown ? null : dropdown);
      };
      
      const navigate = useNavigate();
     
      const handleClick = () => {
        navigate("/Contact#contact-section");
      };
        const [isOpen, setIsOpen] = useState(false);
              
                // const toggleDropdown = () => {
                //   setIsOpen((prev) => !prev);
                // };
          
          
                const [isServicesOpen, setIsServicesOpen] = useState(false);
            const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
            const [isCompanyOpen, setIsCompanyOpen] = useState(false);
          
            // Toggle functions for dropdowns
            const toggleServicesDropdown = () => {
              setIsServicesOpen(!isServicesOpen);
              setIsIndustriesOpen(false);
              setIsCompanyOpen(false); // Close other dropdowns
            };
          
            const toggleIndustriesDropdown = () => {
              setIsIndustriesOpen(!isIndustriesOpen);
              setIsServicesOpen(false);
              setIsCompanyOpen(false); // Close other dropdowns
            };
          
            const toggleCompanyDropdown = () => {
              setIsCompanyOpen(!isCompanyOpen);
              setIsServicesOpen(false);
              setIsIndustriesOpen(false); // Close other dropdowns
            };
                const [word, setWord] = useState('Today');
          
            useEffect(() => {
              const interval = setInterval(() => {
                setWord((prev) => (prev === 'Today' ? 'Tomorrow' : 'Today'));
              }, 2000);
              return () => clearInterval(interval);
            }, []);


  const toggleSlider = () => {
    setIsOpen((prev) => !prev);
  };
  return (
    <>
        <ToastContainer position="top-right" autoClose={3000} />
        <div className="top-0 z-50 w-full">
  <div className="relative bg-[#FFE9AC] py-2 px-3 text-center text-gray-800 text-[13px] sm:text-sm md:text-base font-medium flex items-center justify-center">
    
    {/* Left Emoji */}
    <div className="absolute left-0 top-1/2 transform -translate-y-1/2">
      <img
        src={emojiLeft}
        alt="Celebration emoji"
        className="h-5 w-5 sm:h-6 sm:w-6 md:h-7 md:w-7"
      />
    </div>

    {/* Center Text and Emojis */}
    <div className="flex flex-wrap items-center justify-center gap-1 px-6 text-center leading-tight">
      {/* Emoji group - hidden on mobile */}
      <span className="hidden sm:flex items-center gap-1">
        <img src={emojiConfetti} alt="Confetti" className="h-4 w-4 sm:h-5 sm:w-5" />
      </span>

     <span className="text-[11px] sm:text-[12px] md:text-[13px] leading-tight">
  We are proud to announce that we have completed&nbsp;
  <span className="text-green-700 font-semibold">6 successful years!</span>
</span>

      {/* Emoji group - hidden on mobile */}
      <span className="hidden sm:flex items-center gap-1">
        <img src={emojiParty} alt="Party" className="h-4 w-4 sm:h-5 sm:w-5" />
        <img src={emojiConfetti} alt="Confetti" className="h-4 w-4 sm:h-5 sm:w-5" />
      </span>
    </div>

    {/* Right Emoji */}
    <div className="absolute right-0 top-1/2 transform -translate-y-1/2">
      <img
        src={emojiRight}
        alt="Celebration emoji"
        className="h-5 w-5 sm:h-6 sm:w-6 md:h-7 md:w-7"
      />
    </div>
  </div>
</div>
<header className="sticky top-0 z-50 w-full bg-white border-b border-gray-100 shadow-sm">
             <div className="mx-auto flex max-w-screen-xl items-center justify-between px-4 py-2 md:px-8">
               {/* Logo */}
               <div className="flex items-center space-x-2">
                 <Link to="/">
                   <img
                     src={logo}
                     alt="Lentera Logo"
                     className="h-8 w-auto"
                   />
                 </Link>
               </div>
       
               {/* Hamburger Icon for Mobile */}
               <button
                 className="lg:hidden flex items-center"
                 onClick={toggleMobileMenu}
                 aria-label="Toggle mobile menu"
               >
                 <svg
                   className="h-6 w-6 text-gray-800"
                   fill="none"
                   stroke="currentColor"
                   viewBox="0 0 24 24"
                   xmlns="http://www.w3.org/2000/svg"
                 >
                   <path
                     strokeLinecap="round"
                     strokeLinejoin="round"
                     strokeWidth="2"
                     d={isMobileMenuOpen ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16M4 18h16'}
                   />
                 </svg>
               </button>
       
               {/* Desktop Navigation */}
   <nav
       ref={navRef}
       className="hidden lg:flex items-center space-x-6 text-sm font-medium text-gray-800 ml-13"
     >
       {/* --- Services Dropdown --- */}
       <div className="relative">
         <div className="flex items-center gap-1">
           <a
             href="#"
             className="text-black hover:text-black flex items-center"
             onClick={(e) => {
               e.preventDefault();
               toggleDropdown('services');
             }}
           >
             Services
             <img
               src={dd}
               alt="Dropdown arrow"
               className={`h-1 w-2 ml-2 mt-1 transition-transform duration-300 ${
                 openDropdown === 'services' ? 'rotate-180' : 'rotate-0'
               }`}
             />
           </a>
         </div>
 
         {openDropdown === 'services' && (
           <div className="absolute top-full left-0 mt-2 w-56 bg-white text-black rounded-lg shadow-lg py-2 z-50">
             {[
              { to: "/services/ai-services/", label: "AI Services" },
              { to: "/services/web-development/", label: "Web Development" },
              { to: "/services/mobile-app-development/", label: "Mobile App Development" },
              { to: "/services/software-consulting/", label: "Software Consulting" },
              { to: "/services/third-party-integration/", label: "Third Party Integration" },
              { to: "/services/custom-development/", label: "Custom Development" },
              { to: "/services/enterprise-application/", label: "Enterprise Application" },
              { to: "/services/digital-transformation/", label: "Digital Transformation" },
            ].map((item) => (
               <Link
                 key={item.to}
                 to={item.to}
                 className="relative block px-4 py-2 hover:bg-gray-100 transition-all duration-300 group flex items-center justify-between"
               >
                 <div className="flex items-center">
                   <span className="absolute left-0 top-0 h-full w-1 bg-[#00A339] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                   <span className="ml-2 text-xs">{item.label}</span>
                 </div>
                 <img
                   src={ar}
                   alt="Right arrow"
                   className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                 />
               </Link>
             ))}
           </div>
         )}
       </div>
 
       {/* --- Industries Dropdown --- */}
       <div className="relative">
         <div className="flex items-center gap-1">
           <a
             href="#"
             className="text-black hover:text-black flex items-center"
             onClick={(e) => {
               e.preventDefault();
               toggleDropdown('industries');
             }}
           >
             Industries
             <img
               src={dd}
               alt="Dropdown arrow"
               className={`h-1 w-2 ml-2 mt-1 transition-transform duration-300 ${
                 openDropdown === 'industries' ? 'rotate-180' : 'rotate-0'
               }`}
             />
           </a>
         </div>
 
         {openDropdown === 'industries' && (
            <div className="absolute top-full left-0 mt-2 w-56 bg-white text-black rounded-lg shadow-lg py-2 z-50">
            {[
              
              { to: "/industries/logistics/", label: "Logistics" },
              { to: "/industries/healthcare/", label: "Healthcare" },
              { to: "/industries/financial-services/", label: "Financial Services" },
              { to: "/industries/education/", label: "Education" },
              { to: "/industries/hospitality/", label: "Hospitality" },
              { to: "/industries/entertainment/", label: "Entertainment" },
              { to: "/industries/energy/", label: "Energy" },
               { to: "/industries/warehouse/", label: "Warehouse" },
              { to: "/industries/manufacture/", label: "Manufacture" },
            ].map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="relative block px-4 py-2 hover:bg-gray-100 transition-all duration-300 group flex items-center justify-between"
              >
                <div className="flex items-center">
                  <span className="absolute left-0 top-0 h-full w-1 bg-[#00A339] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                  <span className="ml-2 text-xs">{item.label}</span>
                </div>
                <img
                  src={ar}
                  alt="Right arrow"
                  className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                />
              </Link>
            ))}
          </div>
         )}
       </div>
 
       {/* --- Company Dropdown --- */}
       <div className="relative">
         <div className="flex items-center gap-1">
           <a
             href="#"
             className="text-black hover:text-black flex items-center"
             onClick={(e) => {
               e.preventDefault();
               toggleDropdown('company');
             }}
           >
             Company
             <img
               src={dd}
               alt="Dropdown arrow"
               className={`h-1 w-2 ml-2 mt-1 transition-transform duration-300 ${
                 openDropdown === 'company' ? 'rotate-180' : 'rotate-0'
               }`}
             />
           </a>
         </div>
 
         {openDropdown === 'company' && (
           <div className="absolute top-full left-0 mt-2 w-56 bg-white text-black rounded-lg shadow-lg py-2 z-50">
             {[
              { to: "/company/our-advantages/", label: "Our advantages" },
              { to: "/company/people-of-lentera/", label: "People of Lentera" },
              { to: "/company/our-brand/", label: "Our Brand" },
              { to: "https://blog.lentera.in/", label: "Blogs", external: true },
              { to: "https://www.lentera.in/contact-us/", label: "Support us", external: true },
              // { to: "/company/certifications/", label: "Certifications" },
            ].map((item) =>
               item.external ? (
                 <a
                   key={item.to}
                   href={item.to}
                   target="_blank"
                   rel="noopener noreferrer"
                   className="relative block px-4 py-2 hover:bg-gray-100 transition-all duration-300 group flex items-center justify-between"
                 >
                   <div className="flex items-center">
                     <span className="absolute left-0 top-0 h-full w-1 bg-[#00A339] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                     <span className="ml-2 text-xs">{item.label}</span>
                   </div>
                   <img
                     src={ar}
                     alt="Right arrow"
                     className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                   />
                 </a>
               ) : (
                 <Link
                   key={item.to}
                   to={item.to}
                   className="relative block px-4 py-2 hover:bg-gray-100 transition-all duration-300 group flex items-center justify-between"
                 >
                   <div className="flex items-center">
                     <span className="absolute left-0 top-0 h-full w-1 bg-[#00A339] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                     <span className="ml-2 text-xs">{item.label}</span>
                   </div>
                   <img
                     src={ar}
                     alt="Right arrow"
                     className="h-4 w-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                   />
                 </Link>
               )
             )}
           </div>
         )}
       </div>
 
       {/* --- Contact Link --- */}
       <Link to="/contact/" className="text-black hover:text-black">
         Contact us
       </Link>
     </nav>
       
               {/* Desktop Language Selector + CTA */}
               <div className="hidden lg:flex items-center gap-3">
                 {/* <button className="flex items-center gap-2 rounded-full border border-gray-300 px-4 py-1 text-sm font-medium text-gray-700 shadow-sm">
                   <img
                     src={ind}
                     alt="India Flag"
                     className="h-4 w-4 rounded-full"
                   />
                   India (English)
                   <ChevronDown className="h-4 w-4" />
                 </button> */}
                  {/* <button
  onClick={handleClick}
  className="w-[175px] h-[44px] rounded-full bg-green-600 px-5 py-2 text-sm font-semibold text-white hover:bg-green-700"
>
  Get a Free Quote
</button> */}

    <button
        onClick={toggleSlider}
        className="w-[240px] h-[44px] rounded-full bg-green-600 px-5 py-2 text-sm font-semibold text-white hover:bg-green-700"
      >
        Book a Free Consultation
      </button>

      {/* Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={toggleSlider}
        />
      )}

      {/* Sliding Panel */}
      <div
        className={`fixed top-0 right-0 h-full w-full sm:w-[90%] md:w-[100%] lg:w-[100%] bg-white shadow-xl z-50 transform transition-transform duration-300 ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex flex-col h-full">
          {/* Close Button */}
          <div className="text-right p-4">
            <button
              onClick={toggleSlider}
              className="text-2xl font-bold text-gray-700 hover:text-red-500"
              aria-label="Close Panel"
            >
              ❌
            </button>
          </div>

          {/* Iframe Content */}
          <iframe
            src="https://outlook.office365.com/book/FreeConsultation@lenteratechno.onmicrosoft.com/"
            title="Book a Free Consultation"
            className="flex-1 w-full border-none"
          />
        </div>
      </div>
               </div>
             </div>
       
             {/* Mobile Menu */}
             {isMobileMenuOpen && (
              <div className="lg:hidden bg-white border-t border-gray-100">
                <nav className="flex flex-col px-4 py-4 space-y-2 text-sm font-medium text-gray-800">
                  <div>
                    <button
                      className="flex items-center justify-between w-full text-black hover:text-black py-2"
                      onClick={toggleServicesDropdown}
                    >
                      Services
                      <img
                        src={dd}
                        alt="Dropdown arrow"
                        className={`h-1 w-2 transition-transform duration-300 ${
                          isServicesOpen ? 'rotate-180' : 'rotate-0'
                        }`}
                      />
                    </button>
                    {isServicesOpen && (
                      <div className="mt-2 space-y-1">
                        <Link
                          to="/services/ai-services/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Ai Services
                        </Link>
                        <Link
                          to="/services/web-development/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Web Development
                        </Link>
                        <Link
                          to="/services/mobile-app-development/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Mobile App Development
                        </Link>
                        <Link
                          to="/services/software-consulting/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Software Consulting
                        </Link>
                        <Link
                          to="/services/third-party-integration/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Third Party Integration
                        </Link>
                        <Link
                          to="/services/custom-development/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Custom Development
                        </Link>
                        <Link
                          to="/services/enterprise-application/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Enterprise Application
                        </Link> <Link
                          to="/services/digital-transformation/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Digital Transformation
                        </Link>

                      </div>
                    )}
                  </div>
                  <div>
                    <button
                      className="flex items-center justify-between w-full text-black hover:text-black py-2"
                      onClick={toggleIndustriesDropdown}
                    >
                      Industries
                      <img
                        src={dd}
                        alt="Dropdown arrow"
                        className={`h-1 w-2 transition-transform duration-300 ${
                          isIndustriesOpen ? 'rotate-180' : 'rotate-0'
                        }`}
                      />
                    </button>
                    {isIndustriesOpen && (
                      <div className="mt-2 space-y-1">
                        
                        <Link
                          to="/industries/logistics/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Logistics
                        </Link>
                        <Link
                          to="/industries/healthcare/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Healthcare
                        </Link>
                        <Link
                          to="/industries/financial-services/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Financial Services
                        </Link>
                        <Link
                          to="/industries/education/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Education
                        </Link>
                        <Link
                          to="/industries/hospitality/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Hospitality
                        </Link>
                        <Link
                          to="/industries/entertainment/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Entertainment
                        </Link>
                        <Link
                          to="/industries/energy/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Energy
                        </Link>
                        <Link
                          to="/industries/warehouse/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Warehouse
                        </Link>
                         <Link
                          to="/industries/manyufacture/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Manufacture
                        </Link>
                        <Link
 to="/industries/ecommerce/"
 className="block px-4 py-2 text-xs hover:bg-gray-100"
 onClick={() => setIsMobileMenuOpen(false)}
 >
 E-commerce
 </Link>

                      </div>
                    )}
                  </div>
                  <div>
                    <button
                      className="flex items-center justify-between w-full text-black hover:text-black py-2"
                      onClick={toggleCompanyDropdown}
                    >
                      Company
                      <img
                        src={dd}
                        alt="Dropdown arrow"
                        className={`h-1 w-2 transition-transform duration-300 ${
                          isCompanyOpen ? 'rotate-180' : 'rotate-0'
                        }`}
                      />
                    </button>
                    {isCompanyOpen && (
                      <div className="mt-2 space-y-1">
                        <Link
                          to="/company/our-advantages/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Our advantages
                        </Link>
                        <Link
                          to="/company/people-of-lentera/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          People Of Lentera
                        </Link>
                         <Link
                          to="/company/our-brand/"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Our Brand
                        </Link>
                        {/* <Link
                        to="/company/certifications/"
                        className="block px-4 py-2 text-xs hover:bg-gray-100"
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        Certifications
                      </Link>    */}
                    <a
  href="https://blog.lentera.in/"
  target="_blank"
  rel="noopener noreferrer"
  className="block px-4 py-2 text-xs hover:bg-gray-100"
  onClick={() => setIsMobileMenuOpen(false)}
>
  Blogs
</a>

                        {/* <Link
                          to="/certifications"
                          className="block px-4 py-2 text-xs hover:bg-gray-100"
                          onClick={() => setIsMobileMenuOpen(false)}
                        >
                          Certifications
                        </Link> */}
                      <a
  href="https://www.lentera.in/contact-us/"
  target="_blank"
  rel="noopener noreferrer"
  className="block px-4 py-2 text-xs hover:bg-gray-100"
  onClick={() => setIsMobileMenuOpen(false)}
>
  Support us
</a>

                      </div>
                    )}
                  </div>
                  <Link
                    to="/Contact/"
                    className="block py-2 text-sm hover:bg-gray-100"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    Contact us
                  </Link>
                  {/* <button className="flex items-center gap-2 py-2 text-sm font-medium text-gray-700">
                    <img
                      src={ind}
                      alt="India Flag"
                      className="h-4 w-4 rounded-full"
                    />
                    India (English)
                    <ChevronDown className="h-4 w-4" />
                  </button> */}
          {/* <button
                 onClick={handleClick}
  className="block py-2 text-sm font-semibold text-white bg-green-600 rounded-full hover:bg-green-700"
  // onClick={() => {
  //   const section = document.getElementById("contact-section");
  //   if (section) {
  //     section.scrollIntoView({ behavior: "smooth" });
  //   }
  // }}
>
  Get a Free Quote
</button> */}
    <button
        onClick={toggleSlider}
        className="w-[240px] h-[44px] rounded-full bg-green-600 px-5 py-2 text-sm font-semibold text-white hover:bg-green-700"
      >
        Book a Free Consultation
      </button>

      {/* Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={toggleSlider}
        />
      )}

      {/* Sliding Panel */}
      <div
        className={`fixed top-0 right-0 h-full w-full sm:w-[90%] md:w-[100%] lg:w-[100%] bg-white shadow-xl z-50 transform transition-transform duration-300 ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex flex-col h-full">
          {/* Close Button */}
          <div className="text-right p-4">
            <button
              onClick={toggleSlider}
              className="text-2xl font-bold text-gray-700 hover:text-red-500"
              aria-label="Close Panel"
            >
              ❌
            </button>
          </div>

          {/* Iframe Content */}
          <iframe
            src="https://outlook.office365.com/book/FreeConsultation@lenteratechno.onmicrosoft.com/"
            title="Book a Free Consultation"
            className="flex-1 w-full border-none"
          />
        </div>
      </div>
                </nav>
              </div>
            )}
           </header>
            <section className="relative bg-[#f7f8fa] pt-20 pb-10 overflow-hidden font-poppins">
      {/* Headings Section */}
      <div className="text-center px-4 max-w-[960px] mx-auto relative">
        <h1 className="text-[40px] sm:text-[52px] md:text-[64px] font-semibold leading-tight text-gray-900">
  We are <span className="font-bold font-[Aclonica]">Lentera</span>.
</h1>


        <h2 className="text-[30px] sm:text-[42px] md:text-[56px] text-gray-800 mt-1 leading-tight">
          where innovation begins.
        </h2>

        <div className="w-[60px] h-[3px] bg-green-600 mx-auto my-5" />

        <p className="text-gray-700 text-[17px] sm:text-[18px] md:text-[20px] leading-relaxed font-light mt-4">
          In 2019, within a small apartment in suburban Chennai, a bold idea was born:
          <span className="font-semibold text-[#1f4d3a] inline-block bg-teal-100 px-1.5 rounded-sm mx-1">
            “Build smart technology to help businesses work better”.
          </span>
          What began as a simple spark has grown into a world-class tech company — powering
          the way modern businesses thrive.
        </p>

        {/* Left green curve */}
        <img
          src={curveIcon}
          alt="curve"
          className="absolute top-[290px] left-[40] w-[32px] md:w-[38px] hidden md:block"
        />

        {/* Right yellow arrow */}
        <div className="hidden lg:flex flex-col items-center absolute bottom-[-80px] -right-[80px] rotate-[-25deg] text-sm text-gray-800 font-semibold">
          <span className="mb-1 text-center leading-tight">Moments<br />of Lentera</span>
          <img src={arrowIcon} alt="arrow" className="w-[60px] h-[60px]" />
        </div>
      </div>

      {/* Scrolling Image Carousel */}
      <div className="relative mt-20 h-[400px] md:h-[420px] overflow-hidden">
        {/* Top curve */}
        <div className="absolute top-0 left-0 w-full h-[90px] z-10 overflow-hidden pointer-events-none">
          <svg viewBox="0 0 1440 90" className="w-full h-full" preserveAspectRatio="none">
            <path fill="#f7f8fa" d="M0,80 C320,0 1120,0 1440,80 L1440,0 L0,0 Z" />
          </svg>
        </div>

        {/* Side gradients */}
        <div className="absolute top-0 left-0 w-24 h-full z-10 bg-gradient-to-r from-[#f7f8fa] to-transparent pointer-events-none" />
        <div className="absolute top-0 right-0 w-24 h-full z-10 bg-gradient-to-l from-[#f7f8fa] to-transparent pointer-events-none" />

        {/* Scrolling images */}
        <div className="relative z-0 w-full h-full">
          <motion.div
            className="absolute top-0 left-0 flex gap-[28px] px-[28px]"
            style={{ width: "max-content" }}
            animate={{ x: ["0%", "-50%"] }}
            transition={{ duration: 60, repeat: Infinity, ease: "linear" }}
          >
            {[...imagess, ...imagess].map((src, i) => (
              <div
                key={i}
                className="w-[280px] sm:w-[360px] md:w-[400px] h-[240px] sm:h-[300px] md:h-[320px] rounded-xl overflow-hidden flex-shrink-0"
              >
                <img
                  src={src}
                  alt={`scroll-img-${i}`}
                  className="w-full h-full object-cover"
                />
              </div>
            ))}
          </motion.div>
        </div>

        {/* Bottom curve */}
        <div className="absolute bottom-0 left-0 w-full h-[90px] z-10 overflow-hidden pointer-events-none">
          <svg viewBox="0 0 1440 90" className="w-full h-full" preserveAspectRatio="none">
            <path fill="#f7f8fa" d="M0,50 C360,0 1080,100 1440,50" />
          </svg>
        </div>
      </div>
    </section>
    
     

     <section className="w-full bg-[#F8F9FB] py-16 px-6 lg:px-20 text-center font-poppins">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="max-w-4xl mx-auto"
            >
              <h2 className="text-4xl sm:text-6xl font-bold leading-tight mb-4">
                <span className="bg-gradient-to-r from-[#07862B] to-[#FFEE2F] bg-clip-text text-transparent">
                  6+
                </span>{" "}
                <span className="bg-gradient-to-r from-[#07862B] to-[#FFEE2F] bg-clip-text text-transparent">years</span>
              </h2>
              <p className="text-gray-800 text-lg sm:text-xl">
                of running a business has taught<br/> us many things
              </p>
            </motion.div>
          </section>
     
<section className="w-full bg-white font-poppins py-20 px-6 lg:px-20">
  <div className="flex flex-col lg:flex-row gap-10 relative">
    {/* LEFT STICKY IMAGE DISPLAY */}
    <div className="lg:w-[40%] w-full relative">
      <div className="sticky top-20 flex justify-center items-center h-[400px] md:h-[500px]">
        <div className="relative w-full flex justify-center items-center">
          {images[activeIndex].circleColor && (
            <div
              className={`absolute w-48 h-48 md:w-64 md:h-64 ${images[activeIndex].circleColor} rounded-full top-8 left-4 -z-10`}
            />
          )}
          <img
            src={images[activeIndex].src}
            alt={images[activeIndex].alt}
            className="w-[280px] md:w-[400px] lg:w-[469px] h-auto object-contain drop-shadow-xl"
          />
          {activeIndex === 2 && (
            <div className="text-center mt-4">
              {/* <h3 className="text-sm md:text-base font-semibold text-gray-900 leading-tight">
                Sasi kumar S
              </h3>
              <p className="text-xs md:text-sm text-gray-500">
                Founder & CEO of Lentera
              </p> */}
            </div>
          )}
        </div>
      </div>
    </div>

    {/* RIGHT TIMELINE CONTENT */}
    <div className="lg:w-[60%] w-full flex flex-col gap-20">

      {/* Block 1 */}
      <div ref={sectionRefs[0]}>
        <h2 className="text-[40px] md:text-[48px] font-normal text-gray-900 leading-tight mb-6">
          The Spark - Year of <br className="hidden sm:block" />
          Inception (2019)
        </h2>

        <div className="relative bg-[#FFF3D6] px-6 py-6 rounded-md mb-6 shadow-sm">
          <span className="absolute -left-6 -top-5 text-yellow-500 text-[40px] md:text-[56px] font-serif leading-none">
            &ldquo;
          </span>
          <p className="text-[18px] md:text-[20px] text-gray-800 font-medium md:font-semibold leading-relaxed">
            We believe the best software is built by small teams in informal,
            collaborative environments — not by chasing numbers or rigid metrics.
          </p>
          <span className="absolute -right-6 -bottom-5 text-yellow-500 text-[40px] md:text-[56px] font-serif leading-none">
            &rdquo;
          </span>
        </div>

        <p className="text-gray-700 text-[18px] font-light leading-relaxed mb-4">
          In 2019, inside a modest apartment in suburban Chennai, a bold idea was born — build smart technology to help businesses work better.
        </p>
        <p className="text-gray-700 text-[18px] font-light leading-relaxed mb-4">
          With limited resources but unlimited determination, Lentera was born — not in a boardroom, but at a kitchen table surrounded by laptops, whiteboards, and ideas that wouldn’t quit.
        </p>
        <p className="text-gray-700 text-[18px] font-light leading-relaxed">
          This was our beginning — humble, hungry, and human.
        </p>
      </div>

      {/* Block 2 */}
      <div ref={sectionRefs[1]}>
        <h2 className="text-[40px] md:text-[48px] font-normal text-gray-900 leading-tight mb-6">
          The original problem we <br className="hidden sm:block" />
          aimed to solve
        </h2>

        <div className="relative bg-[#FFF3D6] px-6 py-6 rounded-md mb-6 shadow-sm">
          <span className="absolute -left-6 -top-5 text-yellow-500 text-[40px] md:text-[56px] font-serif leading-none">
            &ldquo;
          </span>
          <p className="text-[18px] md:text-[20px] text-gray-800 font-medium md:font-semibold leading-relaxed">
            Too many tools. Too little clarity. We knew there had to be a smarter way to work.
          </p>
          <span className="absolute -right-6 -bottom-5 text-yellow-500 text-[40px] md:text-[56px] font-serif leading-none">
            &rdquo;
          </span>
        </div>

        <p className="text-gray-700 text-[18px] font-light leading-relaxed mb-4">
          Back in 2019, we noticed a common pattern across businesses — too many tools, too much complexity, and not enough clarity. Teams were drowning in outdated systems, inefficient workflows, and disconnected platforms that slowed them down instead of lifting them up.
        </p>
        <p className="text-gray-700 text-[18px] font-light leading-relaxed mb-4 font-semibold mb-2">
          That question led to our mission:
        </p>
        <p className="text-gray-700 text-[18px] font-light leading-relaxed mb-4">
          To design intelligent digital solutions that solve real business challenges — not create new ones.{" "}
          <span className="bg-emerald-100 px-1 italic font-semibold">
            We didn’t set out to reinvent the wheel. We set out to make it roll smoother.
          </span>
        </p>
      </div>

      {/* Block 3 */}
      <div ref={sectionRefs[2]}>
        <h2 className="text-[40px] md:text-[48px] font-normal text-gray-900 leading-tight mb-6">
          Who founded it & started <br className="hidden sm:block" />
          it with great will
        </h2>

        <div className="relative bg-[#FFF3D6] px-6 py-6 rounded-md mb-6 shadow-sm">
          <span className="absolute -left-6 -top-5 text-yellow-500 text-[40px] md:text-[56px] font-serif leading-none">
            &ldquo;
          </span>
          <p className="text-[18px] md:text-[20px] text-gray-800 font-medium md:font-semibold leading-relaxed">
            we were solving a problem we lived every day. That’s what made it real.
          </p>
          <span className="absolute -right-6 -bottom-5 text-yellow-500 text-[40px] md:text-[56px] font-serif leading-none">
            &rdquo;
          </span>
        </div>

        <p className="text-gray-700 text-[18px] font-light leading-relaxed mb-4">
          Lentera was born from the grit and vision of a few determined individuals who saw possibility where others saw complexity. With no big funding, no safety net — just pure intent, late nights, and relentless curiosity — they set out to build something that mattered.
        </p>
        <p className="text-gray-700 text-[18px] font-light leading-relaxed mb-4">
          Fueled by purpose and a strong will to make a difference, they laid the foundation not just for a company, but for a culture rooted in innovation, integrity, and impact.
        </p>
        <p className="text-gray-900 font-semibold">
          That spirit still drives everything we do today.
        </p>
      </div>
    </div>
  </div>
</section>

    
    <section className="relative bg-[#F9FAFB] py-20 px-4 sm:px-6 lg:px-16 scroll-smooth">
  <h2 className="text-center text-3xl sm:text-4xl md:text-5xl font-semibold text-gray-900 leading-tight">
    The Great Journey of Lentera
  </h2>

  <div className="max-w-7xl mx-auto relative mt-16">
    {/* Vertical Timeline Line */}
    <div
      ref={lineRef}
      className="hidden lg:block absolute left-1/2 w-[2px] bg-gray-300 transform -translate-x-1/2 z-0"
      style={{ top: startDotRef.current?.offsetTop, height: `${lineHeight}px` }}
    >
      <div
        className="absolute top-0 left-0 w-full bg-green-600 transition-all duration-700 ease-in-out"
        style={{
          height: `${(activeIndexx + 1) * (lineHeight / timelineData.length)}px`,
        }}
      />
    </div>

    {timelineData.map((step, i) => {
      const isEven = i % 2 === 0;
      const isFirst = i === 0;
      const isLast = i === timelineData.length - 1;

      return (
        <div
          key={i}
          id={`step-${i}`}
          className="relative py-20 flex flex-col lg:flex-row items-center justify-between gap-12"
        >
          {/* Dot */}
          <div
            ref={isFirst ? startDotRef : isLast ? endDotRef : null}
            className="absolute hidden lg:block left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10"
          >
            <div
              className={`w-4 h-4 rounded-full border-4 ${
                activeIndexx >= i
                  ? "bg-green-600 border-green-600"
                  : "bg-white border-gray-400"
              }`}
            />
          </div>

          {/* Left Side - Image and Date */}
          <div
            className={`w-full lg:w-1/2 flex justify-center items-start ${
              isEven ? "lg:order-1" : "lg:order-2"
            }`}
          >
            <div className="relative">
              {/* Date Badge - only shown on lg and up */}
              <div
                className={`absolute top-8 ${
                  isEven ? "right-1 translate-x-1/2" : "left-1 -translate-x-1/2"
                } -translate-y-1/2 z-30 hidden lg:block`}
              >
                <div className="bg-gradient-to-r from-[#7B41E6] to-[#EF3BF2] text-white text-sm w-[157px] h-[34px] flex items-center justify-center rounded-full border-2 border-white shadow-[10px]">
                  {step.date}
                </div>
              </div>

              {/* Image */}
              <div className="w-[280px] sm:w-[300px] md:w-[360px] h-[280px] sm:h-[340px] md:h-[360px] rounded-full overflow-hidden shadow-lg bg-white border-[6px] border-white flex items-center justify-center">
                <img
                  src={step.image}
                  alt={step.title}
                  className="w-full h-full object-cover rounded-full"
                />
              </div>

              {/* Mobile/Tablet Date (Below image, only below lg) */}
              <div className="block lg:hidden mt-4 text-center">
                <div className="bg-gradient-to-r from-[#7B41E6] to-[#EF3BF2] text-white text-sm w-[157px] h-[34px] mx-auto flex items-center justify-center rounded-full border-2 border-white shadow-[10px]">
                  {step.date}
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Content */}
          <div
            className={`w-full lg:w-1/2 flex justify-center items-start ${
              isEven ? "lg:order-2" : "lg:order-1"
            }`}
          >
            <div className="bg-white shadow-lg rounded-xl p-6 w-full max-w-[492px] text-left">
              <h3 className="text-2xl font-bold text-gray-900 mb-3">{step.title}</h3>
              <p className="text-gray-600 text-base leading-relaxed">
                {step.description}
              </p>
            </div>
          </div>
        </div>
      );
    })}
  </div>
</section>
<section className="bg-white py-20 px-4 flex flex-col items-center">
      {/* Heading */}
      <h2 className="text-3xl md:text-5xl font-semibold text-gray-900 text-center mb-4 leading-tight">
        Our journey through the years
      </h2>
      <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mb-14 leading-relaxed">
        Creating stellar products for our users is always our top priority. We believe it's not
        the big wins, but the small, consistent ones — powered by persistence and
        passion — that truly shape success.
      </p>

      {/* Content Block */}
      <div className="flex flex-col lg:flex-row gap-10 w-full max-w-[1296px]">
        {/* Left – Milestone Image Box */}
        <div className="relative w-full lg:w-[648px] h-[400px] md:h-[484px] rounded-2xl overflow-hidden shadow bg-[#F9F9F9]">
          <img
            src={milestoneImage}
            alt="Milestone Illustration"
            className="absolute bottom-0 w-full h-auto object-contain"
          />
          <img
            src={emojiStar}
            alt="Emoji Star"
            className="absolute top-6 right-6 w-14 h-14"
          />
          <div className="absolute top-16 left-0 right-0 z-10 px-8 text-center">
            <h3 className="text-xl md:text-2xl font-semibold text-gray-900 leading-snug">
              Every win is a milestone <br /> and we celebrate it.
            </h3>
          </div>
          <img
            src={paperPlane}
            alt="Paper Plane"
            className="absolute bottom-[180px] left-5 w-[180px] md:w-[260px] h-auto object-contain"
          />
        </div>

        {/* Right – Stats */}
       
       <div
  ref={ref}
  className="w-full lg:w-[648px] h-auto bg-[#E9FBED] rounded-2xl grid grid-cols-2 md:grid-cols-2 gap-y-6 py-10 px-4 md:h-[484px]"
>
  {stats.map((item, index) => (
    <div
      key={index}
      className={`text-center px-4 ${index % 2 === 0 ? "border-r border-gray-300" : ""}`}
    >
      {/* Updated font size and weight here */}
      <div className="text-[36px] font-[400] text-gray-900">
        {inView ? (
          <CountUp end={item.number} duration={2} suffix={item.suffix} />
        ) : (
          `0${item.suffix}`
        )}
      </div>

      <div className="text-sm text-gray-600 mt-1 uppercase tracking-wide">
        {item.label}
      </div>
    </div>
  ))}
</div>

      </div>
    </section>
      <div className="bg-[#111215] text-white">
   {/* Footer Section */}
   <footer className="px-4 sm:px-8 md:px-12 pt-12 pb-4">
     {/* Newsletter Section */}
     <div className="w-full bg-[#111215] max-w-[1312px] mx-auto rounded-[24px] md:rounded-[48px] px-4 sm:px-8 md:px-12 py-8 md:py-12 shadow-[0_25px_80px_0_rgba(0,0,0,0.05)] flex flex-col gap-10">
       {/* Top newsletter */}
       <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 w-full">
         {/* Left Side */}
         <div className="flex items-start md:items-center gap-4 md:gap-6">
           <img src={news} alt="newsletter" className="w-12 h-12 md:w-[80px] md:h-[80px]" />
           <h2 className="text-xl md:text-[28px] font-bold leading-tight">
             Join our newsletter to <br className="hidden md:block" />
             keep up to date with us!
           </h2>
         </div>
 
   <div className="flex flex-col items-center gap-4 w-full sm:w-[335px]">
  {/* Newsletter input */}
 <div
  className="flex items-center bg-[#111215] border border-[#333] px-4 py-3 sm:px-6 sm:py-4 w-full"
  style={{ borderRadius: "6px" }}
>
  <img src={user} alt="user icon" className="w-5 h-5 mr-3" />
  <input
    type="email"
    value={email}
    onChange={handleChange}
    placeholder="Enter your email"
    className="bg-transparent outline-none text-white placeholder-gray-400 w-full text-sm"
  />
</div>
 
 
  {/* Captcha line (canvas + refresh + input + subscribe button) */}
{/* Outer wrapper to center the row */}
<div className="w-full flex justify-center">
  <div className="flex items-center gap-3">
    {/* Captcha canvas */}
    <div className="captcha-box">
      <canvas
        ref={canvasRef}
        id="captchaCanvas"
        width={60}
        height={40}
        style={{ borderRadius: "6px", overflow: "hidden" }} // Optional inline for extra assurance
      />
    </div>
 
    {/* Refresh button */}
    <button
      onClick={handleReload}
      style={{
        background: "#07862B ",
        color: "#fff",
        border: "none",
        padding: "6px",
        borderRadius: "6px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="23 4 23 10 17 10"></polyline>
        <polyline points="1 20 1 14 7 14"></polyline>
        <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10M1 14l5.36 4.36A9 9 0 0 0 20.49 15"></path>
      </svg>
    </button>
 
    {/* Captcha input */}
    <input
      type="text"
      placeholder="Enter captcha"
      value={userCaptcha}
      onChange={(e) => setUserCaptcha(e.target.value)}
      className="captcha-input"
    />
 
    {/* Subscribe button */}
    <button className="subscribe-button" onClick={handleSubscribe}>
      Subscribe
    </button>
  </div>
</div>
 
<style>{`
  .captcha-box {
    width: 60px !important;
    height: 35px !important;
    border-radius: 6px !important;
    overflow: hidden !important;
    color :131519;
    background-color: #fff !important;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.1) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
 
  .captcha-input {
    padding: 11px 8px !important;
    border-radius: 6px !important;
    border: 1px solid #ccc !important;
    outline: none !important;
    width: 100px !important;
    background: #131519 !important;
    color: #fff !important;
    font-size: 10px !important;
  }
 
  .subscribe-button {
    padding: 10px 16px !important;
    border-radius: 8px !important;
    border: none !important;
    background: #07862B !important;
    color: #fff !important;
    font-weight: bold !important;
    font-size: 13px !important;
    cursor: pointer !important;
    white-space: nowrap !important;
  }
 
  @media(max-width:480px){
    .captcha-input { width: 70px !important; font-size: 12px !important; }
    .subscribe-button { padding: 8px 12px !important; font-size: 12px !important; }
  }
`}</style>
 
</div>
       </div>
 
       {/* Divider */}
       <div className="border-t border-gray-700 w-full" />
 
       {/* Main Footer Content */}
       <div className="flex flex-col lg:flex-row flex-wrap justify-between items-start w-full gap-8 text-[16px]">
         {/* Company Info */}
         <div className="w-full lg:w-[30%]">
           <a href="http://localhost:3000/" aria-label="Lentera Home">
  <img src={nlen} alt="Lentera logo" className="mb-6" />
</a>
           <p className="text-[#d4d4d4] leading-relaxed">
             We are highly experienced in offering software development, mobile
             application development, software consulting and project management
             delivery.
           </p>
           {/* Social Icons */}
           <div className="flex gap-4 mt-6 flex-wrap">
  <a href="https://www.instagram.com/lenteratechnologies/?hl=en" target="_blank" rel="noopener noreferrer">
    <img src={inst} alt="Instagram" className="w-8 h-8" />
  </a>
  <a href="https://www.facebook.com/lenteratechnologies/?ref=pages_you_manage" target="_blank" rel="noopener noreferrer">
    <img src={face} alt="Facebook" className="w-8 h-8" />
  </a>
  <a href="https://www.youtube.com/@lenteratechnologies" target="_blank" rel="noopener noreferrer">
    <img src={you} alt="YouTube" className="w-8 h-8" />
  </a>
  <a href="https://in.linkedin.com/company/lenteratechnologies" target="_blank" rel="noopener noreferrer">
    <img src={lin} alt="LinkedIn" className="w-8 h-8" />
  </a>
  <a href="https://x.com/lenteratech" target="_blank" rel="noopener noreferrer">
    <img src={twi} alt="X" className="w-8 h-8" />
  </a>
</div>

         </div>
 
         {/* Services */}
           <div className="w-full sm:w-[45%] md:w-auto">
           <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">OUR SERVICES</h4>
           <ul className="space-y-2 text-[#d4d4d4]">
  <li><a href="/services/ai-services/" className="hover:text-white">AI services</a></li>
  <li><a href="/services/web-development/" className="hover:text-white">Web development</a></li>
  <li><a href="/services/mobile-app-development/" className="hover:text-white">Mobile app development</a></li>
  <li><a href="/services/software-consulting/" className="hover:text-white">Software consulting</a></li>
  <li><a href="/services/custom-development/" className="hover:text-white">Custom consulting</a></li>
  <li><a href="/services/third-party-integration/" className="hover:text-white">Third party integration</a></li>
  <li><a href="/services/enterprise-application/" className="hover:text-white">Enterprise Application</a></li>
</ul>
         </div>
 
 
         {/* Insights */}
         <div className="w-full sm:w-[45%] md:w-auto">
           <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">INSIGHTS</h4>
           <ul className="space-y-2 text-[#d4d4d4]">
  <li><a href="https://blog.lentera.in/" className="hover:text-white">Blog</a></li>
  <li><a href="https://www.lentera.in/careers/" className="hover:text-white">Careers</a></li>
  <li><a href="https://blog.lentera.in/" className="hover:text-white">News</a></li>
</ul>
         </div>
 
         {/* Contact */}
         <div className="w-full md:w-auto">
                    <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">CONTACT US</h4>
                        <div className="flex items-start gap-3 mb-3">
                    <img src={phone} alt="phone" className="w-9 h-9 mt-1" />
                    <div>
                      <p className="text-[#999] text-sm">Phone number</p>
                      <a href="tel:+914448563345" className="text-white font-medium text-sm hover:underline">
                        +91-44-4856-3345
                      </a>
                    </div>
                  </div>
         
         <div className="flex items-start gap-3 mb-3">
           <img src={mail} alt="email" className="w-9 h-9 mt-1" />
           <div>
             <p className="text-[#999] text-sm">Email address</p>
             <a href="mailto:info@lenteratech.com" className="text-white font-medium text-sm hover:underline">
               info@lenteratech.com
             </a>
           </div>
         </div>
         
                    <div className="flex items-start gap-3">
           <img src={loc} alt="location" className="w-9 h-9 mt-1" />
           <div>
             <p className="text-[#999] text-sm">Location</p>
             <a
               href="https://www.google.com/maps/place/G1,+Plot+No,+824+and+826,+3rd+Main+Rd,+Ram+Nagar+South,+Madipakkam,+Chennai,+Tamil+Nadu+600091"
               target="_blank"
               rel="noopener noreferrer"
               className="text-white font-medium text-sm hover:underline block"
             >
               G1, Plot No, 824 and 826, 3rd<br />
               Main Rd, Ram Nagar South,<br />
               Madipakkam, Chennai,<br />
               Tamil Nadu 600091
             </a>
           </div>
         </div>
         
                  </div>
       </div>
     </div>
   </footer>
 
   {/* Bottom Section */}
  <div className="bg-[#23262E] border-t border-gray-700 text-sm text-[#ccc] flex flex-col md:flex-row justify-between items-center gap-2 py-4 px-4 sm:px-6 md:px-12 text-center md:text-left">
     <p>© 2025  Lentera Technologies Pvt Ltd. All rights reserved.</p>
     <div className="flex flex-wrap gap-4 justify-center md:justify-end">
       <a href="/terms-condition/" className="hover:underline">Terms and conditions</a>
       <a href="/privacy-policy/" className="hover:underline">Privacy Policy</a>
       <a href="/cookie-policy/" className="hover:underline">Cookies Policy</a>
       <a href="/copyright-information/" className="hover:underline">Copyright information</a>
     </div>
   </div>
 </div>
    </>
  );
}
